import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Table, Button, UncontrolledTooltip, Badge } from 'reactstrap';
import { translate } from "react-translate";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { actionSetEditData } from 'store/actions/usersActions';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import DoctorDetailsModal from './DoctorDetailsModal';

const TableDoctorUsers = (props) => {
    const { data, loading } = props;
    const { t } = props;
    const dispatch = useDispatch();
    const history = useHistory();

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDoctor, setSelectedDoctor] = useState(null);

    const editUser = (e, user) => {
        e.preventDefault();
        dispatch(actionSetEditData({...user}));
        history.push(`/admin/list-users/edit/`);
    }

    const viewDetails = (e, user) => {
        e.preventDefault();
        setSelectedDoctor(user);
        setModalOpen(true);
    }

    const toggleModal = () => setModalOpen(!modalOpen);

    // Calculate ONLY unique patients for the main table view
    const getSummary = (user) => {
        const details = user.associated_details || [];
        const practiceCount = details.length;
        
        const uniquePatients = new Set();
        
        details.forEach(practice => {
            if (practice.patients && Array.isArray(practice.patients)) {
                practice.patients.forEach(p => {
                    // Only count unique IDs
                    if (p.auth_user_id) {
                        uniquePatients.add(p.auth_user_id);
                    }
                });
            }
        });

        return { practiceCount, totalPatients: uniquePatients.size };
    }

    return (
        <>
            <DoctorDetailsModal 
                isOpen={modalOpen} 
                toggle={toggleModal} 
                doctor={selectedDoctor} 
            />

            {loading ?
                (<LoadingLocal />)
                :
                (<div className="table-data">
                    <Table responsive>
                        <thead className="text-primary">
                            <tr>
                                <th> {t("firstName-user")} / {t("lastName-user")}</th>
                                <th> {t("email-user")}</th>
                                <th> {t("location-user")}</th>
                                <th> {t("type-user")}</th>
                                <th> {"External ID"} </th>
                                <th className="text-center"> {t("relations-user")} </th>
                                <th className="text-right"> {t("actions")} </th>
                            </tr>
                        </thead>

                        {data.length > 0 && (data.map((p, index) => {
                            const { practiceCount, totalPatients } = getSummary(p);
                            return (
                                <tbody key={index}>
                                    <tr>
                                        <td>
                                            <span className="font-weight-bold">{p.lastName}</span>, {p.firstName}
                                            <br/>
                                            <small className="text-muted">{p.title}</small>
                                        </td>
                                        <td>
                                            {p.email}
                                            <br/>
                                            <small className="text-muted">{p.phone}</small>
                                        </td>
                                        <td>{p.location || '-'}</td>
                                        <td>
                                            <Badge color={p.membership === 'full' ? 'success' : 'secondary'}>
                                                {p.membership}
                                            </Badge>
                                        </td>

                                        <td>
                                            {p.associated_details ? p.associated_details.map(p => {
                                                return <><small className="text-muted">{p.name}:</small> <b>{p.doctor_ext_ref}</b><br/></>
                                            }) : "-"}
                                        </td>
                                        
                                        <td className="text-center">
                                            <div className="summary-badge">
                                                <i className="fa fa-hospital-o mr-1" />
                                                <span className="summary-highlight">{practiceCount}</span> {t("practice-count-label")}
                                            </div>
                                            <br/>
                                            <div className="summary-badge mt-1">
                                                <i className="fa fa-users mr-1" />
                                                <span className="summary-highlight">{totalPatients}</span> {t("patient-count-label")}
                                            </div>
                                        </td>

                                        <td className="text-right">
                                            <Button
                                                onClick={e => viewDetails(e, p)}
                                                className="btn-icon btn-round btn-neutral"
                                                color="info"
                                                size="sm"
                                                id={`tooltip-details-${index}`}
                                            >
                                                <i className="fa fa-eye" />
                                            </Button>
                                            <UncontrolledTooltip placement="top" target={`tooltip-details-${index}`}>
                                                {t("view-details")}
                                            </UncontrolledTooltip>

                                            <Button
                                                onClick={e => editUser(e, p)}
                                                className="btn-icon btn-round btn-neutral"
                                                color="warning"
                                                size="sm"
                                                id={`tooltip-edit-${index}`}
                                            >
                                                <i className="fa fa-edit" />
                                            </Button>
                                            <UncontrolledTooltip placement="top" target={`tooltip-edit-${index}`}>
                                                {t("edit-action")}
                                            </UncontrolledTooltip>
                                        </td>
                                    </tr>
                                </tbody>
                            )
                        }))}
                    </Table>
                </div>)}
        </>
    );
};

TableDoctorUsers.defaultProps = {
    data: [],
    loading: true
};

TableDoctorUsers.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

export default translate("userList-table")(TableDoctorUsers);